// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"Fp-z","breadcrumbForward":"Gp-z","breadcrumbBack":"Hp-z","selected":"Ip-z"};